"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UI_STATES = exports.UI_STATE_REDIRECT = exports.UI_STATE_PASSED = exports.UI_STATE_HIDDEN = exports.UI_STATE_ERROR = exports.UI_STATE_PROCESSING = exports.UI_STATE_STAND_BY = exports.UI_STATE_INTERACTIVE = exports.UI_STATE_INITIAL = void 0;

/* eslint one-var: "off" */
// начальное состояние, инициализация компонента
var UI_STATE_INITIAL = 'initial'; // активное состояние, UI готов к взаимодействию

exports.UI_STATE_INITIAL = UI_STATE_INITIAL;
var UI_STATE_INTERACTIVE = 'interactive'; // подготовка UI к отображению, загрузка необходимых для работы данных

exports.UI_STATE_INTERACTIVE = UI_STATE_INTERACTIVE;
var UI_STATE_STAND_BY = 'standby'; // обработка действий пользователя

exports.UI_STATE_STAND_BY = UI_STATE_STAND_BY;
var UI_STATE_PROCESSING = 'processing'; // ошибка

exports.UI_STATE_PROCESSING = UI_STATE_PROCESSING;
var UI_STATE_ERROR = 'error'; // компонент скрыт

exports.UI_STATE_ERROR = UI_STATE_ERROR;
var UI_STATE_HIDDEN = 'hidden'; // пройденный шаг (для StepController)

exports.UI_STATE_HIDDEN = UI_STATE_HIDDEN;
var UI_STATE_PASSED = 'passed'; // component is in redirect

exports.UI_STATE_PASSED = UI_STATE_PASSED;
var UI_STATE_REDIRECT = 'redirect';
exports.UI_STATE_REDIRECT = UI_STATE_REDIRECT;
var UI_STATES = {
  INITIAL: UI_STATE_INITIAL,
  INTERACTIVE: UI_STATE_INTERACTIVE,
  STANDBY: UI_STATE_STAND_BY,
  PROCESSING: UI_STATE_PROCESSING,
  ERROR: UI_STATE_ERROR,
  HIDDEN: UI_STATE_HIDDEN,
  REDIRECT: UI_STATE_REDIRECT,
  PASSED: UI_STATE_PASSED
};
exports.UI_STATES = UI_STATES;